import React from "react";
import './student-report.scss';
import { ImageConstants, Constants } from "../../constants/constants";
import { getImageSource } from "../../utility/image-source";
import Loading from "../common/loading/loading";
import SessionCache from "../routes/session-cache";
// import { CircularProgressbar } from "react-circular-progressbar";
import ReactTooltip from 'react-tooltip';
import CommonApi from "../../apis/common";
// import { saveAs } from 'file-saver';
import HomeworkApi from "../../apis/homework";
// import HomeworkForClickerPracticeApi from """;


const greenColor = '#0DB4CB'

class ChapterEloAssessmentReport extends React.Component {

    state = {
        isDownloading: false,
        conceptsList : [],
        createdDate : ''
    }

    componentDidMount() {
        console.log(this.props.selectedItem)
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        this.getStudentDiagnosticReportPDF()
    }



    onClickBack() {
        this.props.delegate && this.props.delegate.hideChapterAssessmentReport && this.props.delegate.hideChapterAssessmentReport()
    }

    getStudentDiagnosticReportPDF(student) {
        let payload = {
            homeworkId: this.props.homeworkId,
            type : this.props.type,
            // userId: this.props.student.userId
        }

        this.setState({isLoading : true})

        HomeworkApi.getStudentHomeworkReport(payload).then(async res => {
            console.log(res)

            this.setState({...res.finalResult, pdfLink :res.pdfLink, isLoading : false})
            // saveAs(res.pdfLink, `${student.studentName}.pdf`)

            // if (window.electron) {
            //     this.downloadPDFUsingElectron(res.pdfLink)
            // }
        }).catch(err => {
            console.log(err)
        })

    }

    downloadPDF() {

        // saveAs(this.state.pdfLink, `${this.state.name}.pdf`)
        
        // this.getStudentDiagnosticReportPDF()
        let url = this.state.pdfLink

        console.log(url)

        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank'
        link.setAttribute(
            'download',
            `FileName.pdf`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);


        if (window.electron) {
            this.downloadPDFUsingElectron(url)
        }

    }

    renderCard(cardInfo, index, minHeightForBorder) {


        return (
            <div className="homework-card" onMouseEnter={ReactTooltip.rebuild}>

                <div className={`homework-card-header py-2 px-2 ${cardInfo.colorClass} `}>
                    <div className='container-1 d-flex align-items-center justify-content-between'>
                        <div>
                            {cardInfo.title}{`${cardInfo.type === 'NOVICE' ? ' (< 50%)' : cardInfo.type === 'PROFICIENT' ? ' (50% - 80%)' : cardInfo.type === 'ADVANCED' ? ' (> 80%)' : ""}`}
                        </div>
                        {
                            this.state.categories[index].students && this.state.categories[index].students.length ?
                                <div className={`d-flex align-items-center`}>
                                    <img className='report-icon  mr-2' src={getImageSource(ImageConstants.WHITE_STUDENTS_COUNT_IMAGE)} />
                                    <span>{this.state.categories[index].students.length}</span>
                                </div>
                                : ""
                        }
                    </div>
                </div>
                <div className="student-list bg-white p-2" style={{
                    height: `${minHeightForBorder * 40}px`,
                    border:
                        `1px solid ${cardInfo.type === 'NOVICE' ? "#FF6464" : cardInfo.type === 'PROFICIENT' ? "#F89D32" : cardInfo.type === 'ADVANCED' ? "#80d2f4" : ""}`
                }}>
                    <div className="">
                        {
                            cardInfo.students?.length ? cardInfo.students.map((student, index) => (
                                <div className="d-flex justify-content-between mb-1">
                                    <div className="student-name">{this.capitalizeWords(student.studentName)} </div>
                                    <div><span className="student-name">{` (${student.percentage}%)`}</span><img className="black_download_icon cursor-pointer" onClick={() => this.getStudentDiagnosticReportPDF(student)} data-tip={`Export to PDF`} src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)} /></div>
                                </div>
                            )) :
                                <div className="text-center" style={{ 'min-width': '400px', fontWeight: '500' }}>No Student </div>}
                    </div>
                </div>
            </div>
        )
    }

    capitalizeWords(input) {
        return input
            .split(' ') // Split the string into an array of words
            .map(word =>
                word
                    .split('.') // Split the word by dots
                    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()) // Capitalize each part
                    .join('.') // Rejoin the parts with dots
            )
            .join(' '); // Join the words back into a single string
    }


    renderCategoryList = () => {

        let minHeightForBorder = ''

        let categories = this.state.categories
        let lengths = []

        for (let i = 0; i < categories.length; i++) {
            let students = categories[i].students
            lengths.push(students.length)
        }

        lengths.sort((a, b) => b - a)

        minHeightForBorder = lengths[0]

        return (
            <div className="category-list mt-4">
                {
                    this.state.categories?.length ? this.state.categories.map((category, index) => (
                        <div className="pr-2">
                            {this.renderCard(category, index, minHeightForBorder)}
                        </div>
                    ))
                        : ""
                }
            </div>
        )
    }

    showStudentCard(type, index, studentsList, statusTitle) {
        if (!studentsList.length) return;
        this.setState({ selectedIndex: index, selectedType: type, students: studentsList, selectedStatusTitle: statusTitle })
    }

    closeStudents() {
        this.setState({ selectedType: null, selectedIndex: -1, students: [], selectedStatusTitle: '', reload: true }, () => {
            this.setState({ reload: false })
        })
    }


    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                {/* <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div> */}

                <div className='position-relative student-card-header-wrapper'>
                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.WRONG)} />
                        </div>
                    </div>
                    <div className='status-title ml-3'>{this.state.selectedStatusTitle}</div>
                </div>

                <div className="min-height-for-student-list">
                    {this.state.students && this.state.students.length ? this.state.students.map((item, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {item.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Records Found</div>
                    }
                </div>


            </div>
        )
    }


    getQuestionTypeProgressBar(questionTypeList) {
        return (
            <div className="">
                {
                    questionTypeList && questionTypeList.length && questionTypeList.map((item, index) => (
                        <div>
                            <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                                {item.questionTypeName} {` (${item.totalQuestions} Q)`}
                                <div className="d-flex position-relative">
                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.notClearedStudents, "Not Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.notCleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.clearedStudents, "Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.cleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                </div>
                            </div>

                            <div className={`row align-items-center ml-0 mr-0 p-1 ${index === questionTypeList.length - 1 ? "" : "mb-4"}`}>
                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                        {
                                            item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                                <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                            </div>

                        </div>
                    ))
                }
            </div>
        )


    }

    getStandardAndCompetencyQuestionsProgressBar(questionTypeList) {
        return (
            <div className="">
                {
                    questionTypeList && questionTypeList.length && questionTypeList.map((item, index) => (
                        <div>
                            <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                                {item.questionTypeName} {` (${item.totalQuestions} Q)`}
                                <div className="d-flex position-relative">
                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.notClearedStudents, "Not Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.notCleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.questionType, index, item.clearedStudents, "Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.cleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.selectedIndex === index && item.questionType === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                </div>
                            </div>

                            <div className={`row align-items-center ml-0 mr-0 p-1 ${index === questionTypeList.length - 1 ? "" : "mb-4"}`}>
                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                    ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                        {
                                            item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                                <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                            </div>

                        </div>
                    ))
                }
            </div>
        )



    }


    getConceptsProgressBar(chapterList) {

        return (
            <div className="">
                {
                    chapterList && chapterList.length && chapterList.map((chapter, cidx) => (
                        <div className="">
                            <div className={`chapter-title mb-2 ${cidx != 0 ? 'mt-3' : ''}`}>{chapter.conceptTitle}</div>
                            <div className=" concept-wrapper">
                                {
                                    chapter.elos && chapter.elos.length && chapter.elos.map((item, index) => (
                                        <>
                                            <div className={`row align-items-center ml-0 mr-0 p-2 ${index === chapter.elos.length - 1 ? "" : "mb-4"}`}>
                                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.percentage !== 0 && item.percentage < 100 ? 'border-right-radius' : ''}`}
                                                        style={{ maxWidth: `${item.percentage}%`, background: `${item.percentage ? "#E78822" : 'none'}` }}>
                                                        {
                                                            item.conceptAverage > 0 ? <div className="average-indicator" style={{ left: `${item.conceptAverage}%` }}>
                                                                <div className="average-number-absolute" style={{ left: `${item.conceptAverage}%` }}>{item.conceptAverage}</div>
                                                            </div> : <></>
                                                        }
                                                        <div className="question-type-name question-name-absolute">{item.eloTitle}</div>
                                                        <div className="question-type-name pr-2 mark-text-absolute">{item.totalCorrectQuestions}/{item.totalQuestions}</div>
                                                    </div>
                                                </div>
                                                <div className="percentage-text ml-1">{item.percentage}%</div>
                                            </div>
                                        </>
                                    ))
                                }
                            </div>

                        </div>
                    ))
                }
            </div>
        )
    }

    getCaseStudyProgressBar(caseStudySkillList) {

        return (
            <div className="">
                {
                    caseStudySkillList ? caseStudySkillList.length ? 
                    caseStudySkillList.map((item, index) => (
                        <div className="">
                            {/* <div className={`chapter-title mb-2 ${cidx != 0 ? 'mt-3' : ''}`}>{chapter.conceptTitle}</div> */}
                            <div className=" concept-wrapper">
                                {

                                    <>
                                        <div className={`row align-items-center ml-0 mr-0 p-2 ${index === caseStudySkillList.length - 1 ? "" : "mb-4"}`}>
                                            <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                                <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.percentage !== 0 && item.percentage < 100 ? 'border-right-radius' : ''}`}
                                                    style={{ maxWidth: `${item.percentage}%`, background: `${item.percentage ? "#7687F3" : 'none'}` }}>
                                                    {
                                                        item.conceptAverage > 0 ? <div className="average-indicator" style={{ left: `${item.conceptAverage}%` }}>
                                                            <div className="average-number-absolute" style={{ left: `${item.conceptAverage}%` }}>{item.conceptAverage}</div>
                                                        </div> : <></>
                                                    }
                                                    <div className={`question-type-name question-name-absolute ${item.percentage > 0 ? 'white-colour' : 'black-colour'} `}>{item.caseStudySkillTitle}</div>
                                                    <div className={`question-type-name pr-2 mark-text-absolute ${item.percentage > 0 ? 'white-colour' : 'black-colour'}`}>{item.totalCorrect}/{item.skillTotal}</div>
                                                </div>
                                            </div>
                                            <div className="percentage-text ml-1">{item.percentage}%</div>
                                        </div>
                                    </>
                                }
                            </div>

                        </div>
                    ))
                    :
                    <div>No Questions Answered</div>
                    :
                    <></>
                }
            </div>
        )
    }

    getChapterList(chapterList) {
        return (
            <div className="">
                {
                    chapterList && chapterList.length && chapterList.map((chapter, cidx) => (
                        <div className="">
                            <div className={`d-flex align-items-center chapter-title-only mb-2 ${cidx != 0 ? 'mt-3' : 'mt-3'}`}><span className="bullet-text">{chapter.conceptTitle}</span></div>
                        </div>
                    ))
                }
            </div>
        )
    }

    getCaseStudySkillQuestionsProgressBar(caseStudySkillList) {
        return (
            <div className="">
                {
                    caseStudySkillList && caseStudySkillList.length && caseStudySkillList.map((item, index) => (
                        <div>
                            <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                                {item.caseStudySkillTitle}{` (${item.totalQuestions} Q)`}
                                <div className="d-flex position-relative">
                                    <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showStudentCard(item.skillName, index, item.notClearedStudents, "Not Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.notCleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.selectedIndex === index && item.skillName === this.state.selectedType && this.state.selectedStatusTitle === 'Not Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                    <div className="d-flex align-items-center ml-2 cursor-pointer" onClick={() => this.showStudentCard(item.skillName, index, item.clearedStudents, "Cleared Students")}>
                                        <img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} />
                                        <div className="students-count d-flex align-items-center">
                                            <span>{item.cleared}</span>
                                            <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.selectedIndex === index && item.skillName === this.state.selectedType && this.state.selectedStatusTitle === 'Cleared Students' ? this.renderStudentCard() : ""
                                    }
                                </div>
                            </div>

                            <div className={`row align-items-center ml-0 mr-0 p-1 ${index === caseStudySkillList.length - 1 ? "" : "mb-4"}`}>
                                <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                                    <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                        style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                        {
                                            item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                                <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                            </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                            </div>

                        </div>
                    ))
                }
            </div>
        )
    }

    getCompetencyProgressBar(item) {
        // console.log(item)
        return (
            <div className="">
                <div>
                    <div className="d-flex align-items-center justify-content-between question-type-name mb-1">
                        Competency
                        <div className="d-flex">
                            <div className="d-flex align-items-center"><img className="image-size mr-2" src={getImageSource(ImageConstants.RED_BG_CROSS_MARK)} /><div className="students-count d-flex align-items-center"><span>{item.notCleared}</span> <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} /></div></div>
                            <div className="d-flex align-items-center ml-2"><img className="image-size mr-2" src={getImageSource(ImageConstants.GREEN_BG_TICK_MARK)} /><div className="students-count d-flex align-items-center"><span>{item.cleared}</span> <img className="student-count-image ml-2 mr-2" src={getImageSource(ImageConstants.BLACK_STUDENTS_COUNT_IMAGE)} /></div></div>
                        </div>
                    </div>

                    <div className={`row align-items-center ml-0 mr-0 p-1`}>
                        <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                            <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${item.correctlyAnsweredPercentage !== 0 && item.correctlyAnsweredPercentage < 100 ? 'border-right-radius' : ''}`}
                                style={{ maxWidth: `${item.correctlyAnsweredPercentage}%`, background: `${item.correctlyAnsweredPercentage ? greenColor : 'none'}` }}>
                                {
                                    item.average > 0 ? <div className="average-indicator" style={{ left: `${item.average}%` }}>
                                        <div className="average-number-absolute" style={{ left: `${item.average}%` }}>{item.average}</div>
                                    </div> : <></>
                                }
                            </div>
                        </div>
                        <div className="percentage-text ml-1">{item.correctlyAnsweredPercentage}%</div>
                    </div>

                </div>
            </div>
        )
    }

    

    downloadAllStudentsReportToPDF() {

        if (this.state.isDownloading) return

        let payload = {
            class: this.state.class,
            section: this.state.sectionName,
            sectionId: this.state.sectionId,
            type: this.state.type,

        }

        if (this.props.homeworkId) {
            payload.homeworkId = this.props.homeworkId ? this.props.homeworkId : null
        }

        this.setState({ isDownloading: true })

        CommonApi.getAllStudentsReportPdf(payload).then((response) => {
            console.log(response)
            // Create a temporary URL for the Blob
            // Create a temporary URL for the Blob

            if (!(response instanceof Blob)) {
                //
                console.log('not a blob')
            }

            // Create a temporary URL for the Blob
            const url = window.URL.createObjectURL(response);

            // Create an anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = this.props.reportType + ' Student Report ' + (new Date).toISOString() + '.zip'; // Name of the downloaded file
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.setState({ isDownloading: false })
            alert('Student Report Downloaded Successfully')

        }).catch(err => {
            this.setState({ isDownloading: false })
            console.log(err)
        })
    }

    downloadPDFUsingElectron(url) {
        window.electron.ipcRenderer.send('download-pdf', {
            payload: {
                fileURL: url
            }
        })
    }

    getTotalScoreProgressBar() {

        let percentage = Math.floor(this.state.markScored / this.state.totalMark * 100)
        let classAverage = this.state.classAverage
        let schoolAverage = this.state.schoolAverage === this.state.classAverage ? this.state.schoolAverage + 0.5 : this.state.schoolAverage

        return (
            <div>
                <div className={`row align-items-center ml-0 mr-0 p-1`}>
                    <div className="col question-type-wrapper pl-0 pr-0 position-relative">
                        <div className={`pl-3 d-flex align-items-center justify-content-between inner-progress-bar
                                ${percentage !== 0 && percentage < 100 ? 'border-right-radius' : ''}`}
                            style={{ maxWidth: `${percentage}%`, background: `${percentage ? greenColor : 'none'}` }}>
                            {/* {
                                classAverage > 0 ? <div className="average-indicator" style={{ left: `${classAverage}%` }}>
                                   
                                </div> : <></>
                            }
                            {
                                schoolAverage > 0 ? <div className="school-average-indicator" style={{ left: `${schoolAverage}%` }}>
                                    
                                </div> : <></>
                            } */}
                        </div>
                        <div className="cleared-question-count">{this.state.markScored}/{this.state.totalMark}</div>
                    </div>
                    <div className="percentage-text ml-1">{percentage}%</div>
                </div>
            </div>
        )

    }

    datePipe(givenDate, isTime = true) {
        givenDate = new Date(givenDate).toString()
        const [day, month, date, year, time] = givenDate.split(' ')
        return `${date} ${month} ${year} ${isTime ? time.substr(0, 5) : ""}`
    }


    render() {


        return (
            <div>
                <div className="student-homework-report">
                    {
                        this.state.isLoading ? <Loading />
                            :
                            <>
                                <div>
                                    <img alt="" className='back-icon cursor-pointer mb-3 mt-3' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                                </div>
                                <div className="school-name">{this.props.selectedItem.class}{this.props.selectedItem.section ? this.props.selectedItem.section : ''}, Student Performance Report</div>

                                <div className="d-flex justify-content-between align-items-center  mb-3">
                                    <div className="header-subtext">{this.state?.userInfo?.schoolInfo?.name}</div>
                                    <div className="d-flex ">
                                        <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadPDF()}>Download Report</div>

                                    </div>
                                </div>

                                <div className="divider-gray"></div>

                                <div className="mt-4">
                                    <div className="student-details-border-container">
                                        <div className="bordered-text">Details</div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div className="student-name student-name-border pr-3">{this.state.name}</div>
                                                <div className="student-name student-name-border pr-3 ml-3">{this.state.class}</div>
                                                <div className="student-name ml-3">Section {this.state.section}</div>
                                            </div>
                                            <div>
                                                <div className="assessment-text">Assessment</div>
                                                <div className="d-flex align-items-center"><img className="mr-2 date-icon" src={getImageSource(ImageConstants.DATE_ICON)} /> <span className="date-text">{this.state.createdDate ? this.datePipe(this.state.createdDate, false) : ''}</span></div>
                                            </div>
                                        </div>

                                        <div className=" mt-2">Chapters :</div>
                                        <div className="mt-2">
                                            {
                                                this.state.chapterTitle && this.state.chapterTitle.map(item => (
                                                    <div className="d-flex align-items-center">
                                                        <div className="dot-circle"></div>
                                                        <div className="concept-title">{item}</div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>

                                </div>

                                <div className="mt-4">
                                    <div className="student-detail-header">Performance Overview</div>
                                    <div className="total-score-border-container mt-4">
                                        <div className="bordered-text">Total Score</div>
                                        <div>
                                            {this.getTotalScoreProgressBar()}
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-6 d-flex align-items-center">
                                                <div className="questions-box d-flex align-items-center">
                                                    <span># Questions </span>
                                                    <span className="bold-text ml-4">{this.state.totalQuestions}</span>
                                                </div>
                                                <div className="questions-box d-flex align-items-center ml-3">
                                                    <span># Correct </span>
                                                    <span className="bold-text ml-4">{this.state.correct}</span>
                                                </div>
                                            </div>
                                            {/* <div className="col-6 d-flex align-items-center justify-content-end">
                                                <div className="class-border-left pl-1">Class Average<span style={{color : '#DEA700', fontWeight : '700'}}>{`(${this.state.classAverage}%)`}</span></div>
                                                <div className="school-border-left pl-1 ml-4">School Average<span style={{color : '#438487', fontWeight : '700'}}>{`(${this.state.schoolAverage}%)`}</span></div>
                                            </div> */}
                                        </div>
                                        <div className="mt-4">
                                            <div className="competency-table mt-4 table-responsive card">
                                                <table className="table table-bordered" style={{}}>
                                                    <thead className="class-header">
                                                        <tr className="first-header-bg">
                                                            <th className="" width=''>Level of Difficulty</th>
                                                            <th>Total Questions</th>
                                                            <th>Attempted Questions</th>
                                                            <th>Total Correct Questions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="rows" className="class-body">
                                                        {
                                                            this.state.questionTypeList &&
                                                            this.state.questionTypeList.length &&
                                                            this.state.questionTypeList.map((item, cidx) => (
                                                                <>
                                                                    <tr>
                                                                        <td className={`class-text border-bottom-left-radius ${cidx === this.state.questionTypeList.length - 1 ? 'bold-text' : ""}`}>
                                                                            {item.questionTypeName}
                                                                        </td>
                                                                        <td className={`class-text border-bottom-left-radius ${cidx === this.state.questionTypeList.length - 1 ? 'bold-text' : ""}`}>
                                                                            {item.totalQuestions}
                                                                        </td>
                                                                        <td className={`class-text border-bottom-left-radius ${cidx === this.state.questionTypeList.length - 1 ? 'bold-text' : ""}`}>
                                                                            {item.totalAttemptedQuestions}
                                                                        </td>
                                                                        <td className={`class-text border-bottom-left-radius ${cidx === this.state.questionTypeList.length - 1 ? 'bold-text' : ""}`}>
                                                                            {item.totalCorrectQuestions}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>

                                </div>


                                <div className="mt-4 mb-4 position-relative">
                                    <div className="chapter-list-border-container">
                                        <div className="bordered-text">{"Conceptwise Performance"}</div>
                                        {
                                            this.getConceptsProgressBar(this.state.chapterList)
                                        }
                                    </div>
                                </div>

                                {/* <div className="mt-4 position-relative">
                                    <div className="case-study-list-border-container">
                                        <div className="bordered-text">Word Problems</div>
                                        {
                                            this.getCaseStudyProgressBar(this.state.caseStudySkillReport)
                                        }
                                    </div>
                                </div> */}

                            </>
                    }

                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div>
        )
    }
}

export default ChapterEloAssessmentReport;